import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import confirmArrow from "../../../assets/images/confirm-arrow.svg";
import Image from "../../atoms/Image/Image";
import TripDetailsForm from "../../molecules/Form/TripDetailsForm";
import ReadMoreList from "../../templates/ConfirmBooking/ReadMoreList/ReadMoreList";
// import locationIcon from '../../../assets/images/location.png'
import fuelIcon from "../../../assets/images/fuel-type.png";
import cancellationIcon from "../../../assets/images/clock-close.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {
  DateTimeHelper,
  CountdownTimer,
} from "../../../helpers/DateTimeHelper";
import couponImage from "../../../assets/images/coupons.png";
import CouponForm from "../../molecules/Form/CouponForm";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import useRequest from "../../../context/useRequest";

const ConfirmBooking = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [offersDetails, setOffersDetails] = useState([]);
  const [promoCodeApplied, setPromoCodeApplied] = useState({
    status: false,
    promocode: "",
    discount: 0,
  });
  const [isError, setIsError] = useState(null);
  const { sendRequest } = useRequest();
  useEffect(() => {
    const fetchOffers = async (vehicleDetails) => {
      try {
        const response = await sendRequest({
          method: "GET",
          url:
            "/promoCode?booking_amount=" +
            (vehicleDetails.base_fare + vehicleDetails.taxes_and_charges),
        });

        if (response && response.data) {
          setOffersDetails(response.data);
        }
      } catch (err) {
        setIsError(err.message);
      }
    };

    if (location.state) {
      const { vehicleDetails } = location.state;
      fetchOffers(vehicleDetails);
    }
  }, [sendRequest]);
  if (isError) {
    return <p className="text-center error">{isError}</p>;
  }
  if (location.state) {
    const { vehicleDetails, searchData, expiryData } = location.state;


    const priceFormat = (price) => {
      if (isNaN(price)) return "0";
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(price);
    };
    return (
      <>
        <section className="information-section py-4">
          <Container>
            <Row>
              <Col className="col-12">
                <h3 className="information-section--title ">Review Booking</h3>
                <div className="d-flex justify-content-between align-items-center information-section--detailTop">
                  <div className="information-section--addressBar mb-2 ">
                    <h6
                      className="information-section--addressBar-address"
                      style={{ maxWidth: "50%" }}
                    >
                      {searchData["pickup-location"]}
                    </h6>
                    <figure className="mb-0 px-3 information-details--addressBar-image">
                      <Image src={confirmArrow} alt="Arrow" />
                    </figure>
                    <h6 className="information-section--addressBar-address ">
                      {searchData["drop-location"]}
                    </h6>
                  </div>

                  <div className="information-section--tripBar">
                    <p className="information-section--tripBar-tripType mb-0">
                      {searchData["search-type"]}
                    </p>
                    <span className="information-section--tripBar-tripType mb-0 px-3">
                      |
                    </span>
                    <p className="information-section--tripBar-tripType mb-0">
                      Pickup :{" "}
                      {DateTimeHelper(
                        searchData["pickup-date"],
                        searchData["pickup-time"]
                      )}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="confirm-section section-padding">
          <Container>
            <Row>
              <Col className="col-12 col-lg-8 mb-lg-0 mb-3">
                <div className="confirm-section--cab">
                  <div className="confirm-section--cab-left w-100">
                    <figure className="mb-3 col-lg-0 search-product--cab-left-image">
                      <Image
                        src={vehicleDetails.image}
                        alt={vehicleDetails.name}
                        width="450"
                        height="300"
                      />
                    </figure>
                    <div className="confirm-section--cab-left-info">
                      <h3 className="h5">{vehicleDetails.name}</h3>
                      <ul className="confirm-section--cab-left-info-table">
                        <li className="mb-0">{vehicleDetails.name}</li>
                        {/* <li className='mb-0'>CNG</li> */}
                        <li className="mb-0">{vehicleDetails.seats} Seats</li>
                        {/* <li className='mb-0'>4 Hrs / 40 kms included</li> */}
                      </ul>
                      <div className="confirm-section--cab-left-details">
                        <h3 className="h6 mb-2">Details</h3>
                        {/* <div className='confirm-section--cab-left-details-fare'>
                                                    <div className='confirm-section--cab-left-details-fare-left'>
                                                        <figure className='mb-0 confirm-section--cab-left-details-fare-left-icon'>
                                                            <img src={locationIcon} alt='subTitle' />
                                                        </figure>
                                                        <h6 className='h6 mb-0'>Extra km fare</h6>
                                                    </div>
                                                    <div className='confirm-section--cab-left-details-fare-right'>
                                                        <p className='mb-0'>₹16.0/km after 148 kms</p>
                                                    </div>
                                                </div> */}
                        {/* <div className='confirm-section--cab-left-details-fare'>
                                                    <div className='confirm-section--cab-left-details-fare-left'>
                                                        <figure className='mb-0 confirm-section--cab-left-details-fare-left-icon'>
                                                            <img src={fuelIcon} alt='subTitle' />
                                                        </figure>
                                                        <h6 className='h6 mb-0'>Fuel Type</h6>
                                                    </div>
                                                    <div className='confirm-section--cab-left-details-fare-right'>
                                                        <p className='mb-0'>Refill breaks</p>
                                                    </div>
                                                </div> */}
                        <div className="confirm-section--cab-left-details-fare">
                          <div className="confirm-section--cab-left-details-fare-left">
                            <figure className="mb-0 confirm-section--cab-left-details-fare-left-icon">
                              <img src={cancellationIcon} alt="subTitle" />
                            </figure>
                            <h6 className="h6 mb-0">Cancellation</h6>
                          </div>
                          <div className="confirm-section--cab-left-details-fare-right">
                            <p className="mb-0">
                              Upto 5 hours before the pickup
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <section className="confirm-section--cabDetails">
                  <h4 className="mb-3 h4">Vehicle & Chauffeur Details</h4>
                  <p className="mb-0">
                    Vehicle and chauffeur details will be shared up to 4 hours
                    before your trip.
                  </p>
                </section>
                <section className="confirm-section--inclusionsExclusions ">
                  <div className="confirm-section--inclusionsExclusions-item">
                    <h3 className="h4 ">
                      <FontAwesomeIcon icon={faCheck} /> Inclusions
                    </h3>
                    <ul className="confirm-section--inclusionsExclusions-item-list m-0">
                      {/* <li>Parking Charges</li>
                                            <li>State Tax</li>
                                            <li>Toll Charges</li>
                                            <li>Driver Allowance</li>
                                            <li>Only One Pickup and Drop<span className="extraInfo"> ( Only one included ) </span></li> */}
                      <li>Fuel Charges</li>
                      <li>Chauffeur Charges</li>
                      <li>Maintenance Charges</li>
                    </ul>
                  </div>
                  <div className="confirm-section--inclusionsExclusions-item">
                    <h3 className="h4">
                      <FontAwesomeIcon icon={faXmark} />
                      Exclusions
                    </h3>
                    <ul className="confirm-section--inclusionsExclusions-item-list m-0">
                      {/* <li>
                                                All Interstate taxes, Permit fee, Toll Taxes, MCD tax, and Parking Charges, etc., shall be extra as per actual.
                                            </li>
                                            <li>
                                                In case where toll is prepaid or E-toll:<br />The number of trips with the amount of per trip toll shall be mentioned on the signed duty slip.
                                            </li> */}
                      <li>GST (5%)</li>
                      <li>Parking Charges</li>
                      <li>Toll Charges</li>
                    </ul>
                  </div>
                </section>
                <TripDetailsForm />
                <ReadMoreList />
              </Col>
              <Col className="col-12 col-lg-4">
                <div className="confirm-section--freeCancellation">
                  <FontAwesomeIcon icon={faClock} />
                  <span>
                    Token Expired After:{" "}
                    <CountdownTimer
                      expiry={expiryData}
                      afterExpiryHandler={() => navigate("/")}
                    />
                  </span>
                </div>
                <div className="confirm-section--payment">
                  <div className="confirm-section--payment--top">
                    <div className="confirm-section--payment--top-label mb-3 ">
                      <div className="d-flex justify-content-between w-100 align-items-center">
                        <p className="mb-0">Base Fare:</p>
                        <h6 className="h6 mb-0">{priceFormat(vehicleDetails.base_fare)}</h6>
                      </div>
                    </div>
                    <div className="confirm-section--payment--top-label mb-3 ">
                      <div className="d-flex justify-content-between w-100 align-items-center">
                        <p className="mb-0">Taxes & Charges:</p>
                        <h6 className="h6 mb-0">
                          {priceFormat(vehicleDetails.taxes_and_charges || "0")}
                        </h6>
                      </div>
                    </div>
                    {promoCodeApplied.status === true ? (
                      <div className="confirm-section--payment--top-label mb-3 ">
                        <div className="d-flex justify-content-between w-100 align-items-center">
                          <p className="mb-0">Discount:</p>
                          <h6 className=" mb-0 red">
                            {priceFormat(promoCodeApplied.discount || "0")}
                          </h6>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="confirm-section--payment-fare ">
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h4 className="h5 mb-0">Total Amount</h4>
                      <p className="mb-0">inc. of tolls and taxes</p>
                    </div>
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h3 className="h3 mb-0">
                        {" "}
                        {priceFormat(vehicleDetails.price - promoCodeApplied.discount)}
                      </h3>
                    </div>
                  </div>
                  <div className="confirm-section--payment-makeCoupons-cabHotDeals">
                    <CouponForm setPromoCodeApplied={setPromoCodeApplied} />
                  </div>
                  <div className="confirm-section--payment-makeCoupons">
                    <div className="confirm-section--payment-makeCoupons-coupons">
                      <Image
                        src={couponImage}
                        alt="couponImage"
                        height="64"
                        width="64"
                      />
                      <p className="mb-0">Available Coupons</p>
                    </div>
                    <ul className="mb-0 p-0 mt-3">
                      {offersDetails.slice(0, 5).map((card, index) => (
                        <li key={index}>{card.promo_code_name}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  } else {
    navigate("/");
  }
};
export default ConfirmBooking;
